module.exports = __webpack_public_path__ + "img/attack_bubbleworm.ac923c05.png";